import type { FC } from "react";

import { classNames } from "@alpacahq/ui/old";

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
}

export const Tabs: FC<TabsProps> = ({
  tabs,
  activeTab,
  onChange,
  className,
}) => {
  return (
    <div className={classNames("flex items-center gap-2", className)}>
      {tabs.map((tab) => (
        <button
          type="button"
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={classNames(
            "rounded-full px-3 py-2 font-semibold text-sm transition-colors duration-200",
            activeTab === tab.id
              ? "bg-indigo-50 text-gray-700"
              : "text-gray-500 hover:text-gray-700",
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
